import AbstractController from '../../../../../vendors/services/abstractController';
import EventoService from '../../../../services/evento.service';
import {useState} from 'react';

export default class NormaDefinitivaController extends AbstractController {

  private eventoService: EventoService;
  public lista: any;
  public setLista: any;

  constructor() {
    super();
    [this.lista, this.setLista] = useState([]);
    this.eventoService = new EventoService();
  }

  obterNormaDefinitiva(cdContribuicao: any) {
    this.start();
    this.eventoService.getNormaDefinitiva(cdContribuicao).then((res: any) => {
      this.stop();
      if (!!res.result && res.result.length > 0) {
        this.setLista(res.result);
      }
    }).catch(err => this.stop());
  }

}
